import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Grid,
  Divider,
} from '@mui/material';
import React from 'react';
import AddProductSpecs from './AddProductSpecs';
import DeleteProductSpec from './DeleteProductSpec';
import EditProductSpecs from './EditProductSpecs';
import useAuthToken from '../../../hooks/getUserData';
import { formatText } from '../../../utility/utils';

const ProductSpecs = ({
  product,
  fetchProduct,
  setMessage,
  setSnackbarOpen,
}) => {
  const token = useAuthToken();

  return (
    <Card>
      <CardHeader
        title="Product details"
        sx={{ paddingBottom: 0 }}
        action={
          <AddProductSpecs
            product={product}
            fetchData={fetchProduct}
            token={token}
            setMessage={setMessage}
            setSnackbarOpen={setSnackbarOpen}
          />
        }
      />
      <CardContent>
        {product.details.length > 0 ? (
          product?.details
            ?.filter((detail) => detail.type !== 'spec')
            .sort((a, b) => {
              const typeOrder = {
                tldr: 1,
                tip: 2,
                good: 3,
                bad: 4,
              };
              return typeOrder[a.type] - typeOrder[b.type];
            })
            .map((detail, index) => (
              <Box
                key={index}
                style={{
                  margin: '16px 0',
                  padding: '16px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                }}>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center">
                  <Grid item xs>
                    <Typography
                      variant="subtitle1"
                      style={{ fontWeight: 'bold', display: 'block' }}>
                      {detail.type === 'tldr'
                        ? 'TL;DR'
                        : detail.type === 'good'
                        ? 'The good'
                        : detail.type === 'bad'
                        ? 'The bad'
                        : detail.type === 'tip'
                        ? 'Pro tips'
                        : 'Specs'}
                    </Typography>
                    {detail.type !== 'spec' ? (
                      <ul
                        style={{
                          paddingLeft: '16px',
                          marginBottom: '8px',
                        }}>
                        <Typography variant="subtitle2">
                          {detail.description.map((item, innerIndex) => (
                            <li key={innerIndex}>
                              {formatText(item)}
                            </li>
                          ))}
                        </Typography>
                      </ul>
                    ) : (
                      <>
                        {detail.name !== '' && (
                          <Typography variant="subtitle2">
                            {detail.type === 'Spec'
                              ? detail.name
                              : `${detail.name}: `}
                            {detail.description.map((item, innerIndex) => (
                              <span key={innerIndex}>
                                {item.charAt(0).toUpperCase() +
                                  item.slice(1).toLowerCase()}
                              </span>
                            ))}
                          </Typography>
                        )}
                      </>
                    )}
                  </Grid>

                  <Grid item xs={2} display="flex" justifyContent="flex-end">
                    <EditProductSpecs
                      detail={detail}
                      fetchData={fetchProduct}
                      token={token}
                      setMessage={setMessage}
                      setSnackbarOpen={setSnackbarOpen}
                    />
                    <DeleteProductSpec
                      detail={detail}
                      fetchData={fetchProduct}
                      token={token}
                      setMessage={setMessage}
                      setSnackbarOpen={setSnackbarOpen}
                    />
                  </Grid>
                </Grid>
              </Box>
            ))
        ) : (
          <Typography
            sx={{ textAlign: 'center' }}
            variant="caption"
            component="p">
            You can add product details here
          </Typography>
        )}
      </CardContent>
      <Divider sx={{ my: 1, backgroundColor: 'rgba(0, 0, 0, 0.5)' }} />
      <CardContent>
        <Typography variant="h5">Product specs</Typography>
        {product.details.length > 0 ? (
          product?.details
            ?.filter((detail) => detail.type === 'spec')
            .map((detail, index) => (
              <Box
                key={index}
                style={{
                  margin: '16px 0',
                  padding: '16px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                }}>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center">
                  <Grid item xs>
                    <Typography
                      variant="subtitle1"
                      style={{ fontWeight: 'bold', display: 'block' }}>
                      {`${detail.name}`}
                    </Typography>
                    {detail.name !== '' && (
                      <Typography variant="subtitle2">
                        {detail.description.map((item, innerIndex) => (
                          <span key={innerIndex}>
                            {formatText(item)}
                          </span>
                        ))}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={2} display="flex" justifyContent="flex-end">
                    <EditProductSpecs
                      detail={detail}
                      fetchData={fetchProduct}
                      token={token}
                      setMessage={setMessage}
                      setSnackbarOpen={setSnackbarOpen}
                    />
                    <DeleteProductSpec
                      detail={detail}
                      fetchData={fetchProduct}
                      token={token}
                      setMessage={setMessage}
                      setSnackbarOpen={setSnackbarOpen}
                    />
                  </Grid>
                </Grid>
              </Box>
            ))
        ) : (
          <Typography
            sx={{ textAlign: 'center' }}
            variant="caption"
            component="p">
            You can add product specs here
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default ProductSpecs;
